import { Component, OnInit } from '@angular/core';
import { Localization } from 'src/app/modules/shared/enums/localization';
import {AccountService} from "../../account.service";
import {TokenService} from "../../../shared/service/token.service";
import {ActivatedRoute, ActivatedRouteSnapshot} from "@angular/router";
import {lastValueFrom} from "rxjs";

@Component({
  selector: 'app-account-deleted',
  templateUrl: './account-deleted.component.html',
  styleUrls: ['./account-deleted.component.scss'],
  providers: [AccountService]
})
export class AccountDeletedComponent implements OnInit {

  public readonly Localization = Localization;
  public deleted = false;

  constructor(
      private readonly accounts: AccountService,
      private readonly token: TokenService,
      private readonly route: ActivatedRoute,
  ) { }

  private get confirmationCode(): string {
    return this.route.snapshot.paramMap.get('code');
  }

  private  get culture(): string {
    return this.route.snapshot.paramMap.get('culture');
  }

  async ngOnInit(): Promise<void> {
    const loginId = this.token.getLoginId();

    await lastValueFrom(this.accounts.confirmAccountDeletion(this.confirmationCode, loginId));

    this.deleted = true;
  }

}
